import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';

function ConfirmSendModal(props) {
  const {
    title,
    message,
    colored,
    header,
    toggle,
    modal,
    onCancel,
    onConfirm,
    t,
  } = props;
  const Icon = <span className="lnr lnr-flag modal__title-icon" />;

  const modalClass = classNames({
    'modal-dialog--colored': colored,
    'modal-dialog--header': header,
  });

  return (
    <div>
      <Modal
        isOpen={modal}
        toggle={toggle}
        className={`modal-dialog--warning ${modalClass} modal-alert`}
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={toggle}
          />
          {header ? '' : Icon}
          <h4 className="bold-text  modal__title">{title}</h4>
        </div>
        <div className="modal__body">{message}</div>
        {onConfirm ? (
          <ButtonToolbar className="modal__footer">
            <Button color="success" onClick={onCancel}>
              {t('general.save')}
            </Button>
            <Button outline={colored} color="warning" onClick={onConfirm}>
              {t('communication.sendNow')}
            </Button>
          </ButtonToolbar>
        ) : null}
      </Modal>
    </div>
  );
}

ConfirmSendModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  colored: PropTypes.bool,
  header: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  modal: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  t: PropTypes.func.isRequired,
};

ConfirmSendModal.defaultProps = {
  title: '',
  message: '',
  colored: false,
  header: false,
  onCancel: null,
  onConfirm: null,
};

export default withTranslation('common')(ConfirmSendModal);
